export default {
  corPrincipal: '#05ACEC',
  corSecundaria: '#0492C9'
}
